<template>
  <div :class="getClass()">
    <input
      :id="name"
      type="checkbox"
      @input="prePareEmit"
      :name="name"
      v-model="modelValue"
      :disabled="isDisabled()"
      :checked="isChecked"
    />
    <label :for="name">
      <div
        class="can-toggle__switch cursor-pointer"
        :data-checked="getLabel('right')"
        :data-unchecked="getLabel('left')"
      ></div>
      <div class="can-toggle__label-text" v-if="label"></div>
    </label>
  </div>
</template>



<style lang="scss">

</style>




<script>
import helper from 'Resources/util/helper';



export default {
  name: "Switcher",

  emits: ['update:modelValue'],

  props: {
    name: {
      default: "a",
      type: String,
      required: false
    },
    lang: {
      default: false,
      type: Boolean,
      required: false
    },
    label: {
      default: undefined,
      type: String,
      required: false
    },
    leftLabel: {
      default: "Off",
      type: [String, Boolean],
      required: false
    },
    rightLabel: {
      default: "On",
      type: [String , Boolean],
      required: false
    },
    disabled: {
      default: false,
      type: [Boolean , String],
      required: false
    },
    json: {
      default: () => {
        return {
          left: false,
          right: true
        };
      },
      type: Object,
      required: false
    },
    cssClass: {
      default: "",
      type: String,
      required: false
    },
    options: {
      default: () => {},
      type: Object,
      required: false
    }
  },

  data() {
    return {
      form: {
        checked: false
      }
    };
  },


  mounted() {
    // console.log('switcher ', this.$attrs.modelValue);
    this.emit(this.$attrs.modelValue);
  },

  computed: {
    isChecked() {
      return this.$attrs.modelValue == this.json.right;
    }
  },

  methods: {
    getClass() {
      return this.cssClass + ' can-toggle';
    },
    isDisabled() {
      return this.disabled || this.disabled == "disabled";
    },
    prePareEmit(e) {
      this.emit(this.getValueText(e.target.checked));
    },
    emit(value) {
      let emitValue = typeof value == 'undefined' ? this.getValueText(false) : value;

      this.$emit("update:modelValue", emitValue);
    },
    getValueText(value) { // value ထဲကို boolean ဝင်လာရင် text_value ပြောင်း
      return helper.castBool(value) ? this.json.right : this.json.left;
    },
    checkActive(value) { // value ထဲကို ဝင်လာတဲ့ boolean | text_value ကို boolean ပြန်ပေး 
      return typeof value == 'boolean' ? value : value == this.json.right;
    },
    getLabel(side) {
      let plainLabel = this[`${side}Label`];

      return helper.hasLocale(`message.${plainLabel}`, this.$t) ? this.$t(`message.${plainLabel}`) : plainLabel;
    }
  }
};
</script>
